import { useSyncExternalStore } from "react";

// Temas de acento DEVOLUZION: verde neón (default), azul, rosa neón.
// robotFilter: los renders del robot son verde lima nativos (~72°) —
//   azul = +135° (actual), verde = nativo, rosa = +263°.
// logoFilter: el isotipo es azul (210°) — verde = -134°, rosa = +125°.
export const THEMES = {
  blue: {
    id: "blue",
    hex: "#007AFF",
    dot: "#007AFF",
    rgbArr: [0, 122, 255],
    screenA: "#4C9AFF",
    screenB: "#9ECBFF",
    robotFilter: "hue-rotate(135deg) saturate(0.85)",
    logoFilter: "none",
  },
  green: {
    id: "green",
    hex: "#B6FF00",
    dot: "#B6FF00",
    rgbArr: [182, 255, 0],
    screenA: "#B6FF00",
    screenB: "#DCFF8A",
    robotFilter: "none",
    logoFilter: "hue-rotate(-134deg)",
  },
  pink: {
    id: "pink",
    hex: "#FF2D8D",
    dot: "#FF2D8D",
    rgbArr: [255, 45, 141],
    screenA: "#FF2D8D",
    screenB: "#FF8AC0",
    robotFilter: "hue-rotate(263deg) saturate(0.85)",
    logoFilter: "hue-rotate(125deg)",
  },
};

const KEY = "dvlz-theme";
let current = THEMES.green;
try {
  const saved = localStorage.getItem(KEY);
  if (saved && THEMES[saved]) current = THEMES[saved];
} catch { /* almacenamiento no disponible */ }

const listeners = new Set();

function applyFavicon(id) {
  const suffix = id === "blue" ? "" : `-${id}`;
  const map = {
    "32x32": `/assets/favicon-32${suffix}.png`,
    "192x192": `/assets/icon-192${suffix}.png`,
  };
  document.querySelectorAll('link[rel="icon"][type="image/png"]').forEach((l) => {
    const size = l.getAttribute("sizes");
    if (map[size]) l.href = map[size];
  });
  const apple = document.querySelector('link[rel="apple-touch-icon"]');
  if (apple) apple.href = `/assets/apple-touch-icon${suffix}.png`;
}

function apply(theme) {
  document.documentElement.dataset.theme = theme.id;
  applyFavicon(theme.id);
}

export function setTheme(id) {
  if (!THEMES[id] || current.id === id) return;
  current = THEMES[id];
  try {
    localStorage.setItem(KEY, id);
  } catch { /* almacenamiento no disponible */ }
  apply(current);
  listeners.forEach((l) => l());
}

export function useTheme() {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current
  );
}

export function getTheme() {
  return current;
}

if (typeof document !== "undefined") apply(current);
;
